import types from './types';

const receiveOmniSubcategories = (subcategories: any) => ({
  type: types.RECEIVE_ALL_OMNI_SUBCATEGORIES,
  subcategories
});

export default { receiveOmniSubcategories };
